<div class="ts1-assessment-ob-table" [class.ts1-assessment-ob-table--preview]="previewMode">
	@if (!hideRoleHeader) {
		<div class="ts1-role-columns-header">
			<div class="ts1-role-column ts1-role-column--pf">
				<span class="ts1-role-badge">PF</span>
			</div>
			<div class="ts1-role-column ts1-role-column--pm">
				<span class="ts1-role-badge ts1-role-badge--pm">PM</span>
			</div>
		</div>
	}

	<mat-accordion [multi]="true" class="ob-selection-accordion">
		@for (OB of TS1_OB_LIST; track OB.title) {
			@let cg = previewMode && !maneuverForm ? null : $safeNavigationMigration(maneuverForm?.get(OB.title));
			<mat-expansion-panel
				class="mat-elevation-z0 ts1-ob-section"
				[expanded]="isSectionExpanded(OB.title)"
				[disabled]="previewMode && !maneuverForm"
			>
				<mat-expansion-panel-header class="ts1-ob-section-header">
					<mat-panel-title>
						<div class="flex w-full items-center gap-2">
							@if (!previewMode || readOnly) {
								<div
									class="size-2 rounded-full"
									[class.bg-violet]="hasValue(OB.title)"
									[class.bg-grey-40]="!hasValue(OB.title)"
								></div>
							}
							<span class="font-bold">{{ OB.name }}</span>
						</div>
					</mat-panel-title>
				</mat-expansion-panel-header>

				@if (cg && (!previewMode || readOnly)) {
					<div [formGroup]="$any(cg)">
						@for (item of OB.item_desc; track $index; let i = $index) {
							@let obKey = OB.title + (i + 1);
							@let obCell = cg.get(obKey);
							@if (obCell) {
								<ng-container
									*ngTemplateOutlet="obRow; context: { $implicit: item, obCell: obCell, title: OB.title, index: i }"
								></ng-container>
							}
						}
					</div>
				}
			</mat-expansion-panel>
		}
	</mat-accordion>
</div>

<ng-template #obRow let-item let-obCell="obCell" let-title="title" let-index="index">
	<div class="ts1-ob-row grid grid-cols-2 border-b border-grey-10">
		<ng-container
			*ngTemplateOutlet="
				obRoleCell;
				context: {
					obCell: obCell,
					title: title,
					index: index,
					role: 'pf',
					description: item.description,
					borderRight: true,
				}
			"
		></ng-container>
		<ng-container
			*ngTemplateOutlet="
				obRoleCell;
				context: {
					obCell: obCell,
					title: title,
					index: index,
					role: 'pm',
					description: item.description,
					borderRight: false,
				}
			"
		></ng-container>
	</div>
</ng-template>

<ng-template
	#obRoleCell
	let-obCell="obCell"
	let-title="title"
	let-index="index"
	let-role="role"
	let-description="description"
	let-borderRight="borderRight"
>
	@let roleControl = $safeNavigationMigration(obCell?.get(role));
	@let roleValue = roleControl?.value;
	@let isConditional = isRoleConditional(obCell, role);
	@let actionMode = isActionMode(title, index, role);
	@let dragging = isDragging(title, index, role);
	<div
		class="ts1-ob-cell"
		[class.border-r]="borderRight"
		[class.border-grey-20]="borderRight"
		[class.ts1-ob-cell--conditional-marked]="isConditional"
		[ngClass]="cellStateClass(obCell, role, title, index)"
		(pointerdown)="onCellPointerDown($event, title, index, role)"
		(pointermove)="onCellPointerMove($event, title, index, role)"
		(pointerup)="onCellPointerUp($event, title, index, role)"
		(pointerleave)="onCellPointerCancel(title, index, role)"
		(pointercancel)="onCellPointerCancel(title, index, role)"
	>
		<div class="ts1-ob-cell__label flex min-w-0 flex-1 items-center gap-2">
			<div class="ts1-ob-dot size-2 shrink-0 rounded-full" [ngClass]="dotStateClass(obCell, role)"></div>
			<mat-icon
				class="ts1-ob-info !h-4 !w-4 shrink-0 text-sm text-grey-40"
				[matTooltip]="description"
				matTooltipPosition="above"
				>info</mat-icon
			>
			<span class="truncate text-sm font-bold">{{ getObLabel(title, index) }}</span>
			@if (roleValue && (roleValue.currentCount > 0 || roleValue.totalCount > 0)) {
				<span class="ob-attempt shrink-0 text-[9px] lg:text-xs"
					>[{{ roleValue.currentCount }}/{{ roleValue.totalCount }}]</span
				>
			}
		</div>

		<div class="ts1-ob-actions" [class.ts1-ob-actions--revealed]="actionMode">
			<div class="ts1-ob-actions__primary">
				<app-ts1-role-ob-counter
					[control]="roleControl"
					[maneuverAction]="maneuverAction"
					[readonly]="previewMode || readOnly"
				></app-ts1-role-ob-counter>
			</div>
			<div
				class="ts1-ob-actions__reveal"
				[class.ts1-ob-actions__reveal--dragging]="dragging"
				[style.width.px]="getRevealVisibleWidth(title, index, role)"
				[attr.aria-hidden]="!actionMode"
			>
				@if (!readOnly && !previewMode) {
					<button
						type="button"
						class="actionBtn actionBtn--conditional"
						[class.actionBtn--conditional-active]="isConditional"
						(click)="onToggleConditional(obCell, role, title, index)"
						(pointerdown)="$event.stopPropagation()"
						(pointerup)="$event.stopPropagation()"
						[matTooltip]="getConditionalActionLabel(isConditional)"
						[attr.aria-label]="getConditionalActionLabel(isConditional)"
					>
						<mat-icon>description</mat-icon>
					</button>
				}
			</div>
		</div>
	</div>
</ng-template>
